import React, { useState, useEffect, useContext } from "react";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import Select, { components } from "react-select";
import ServiceAdmin from "./Services/ServiceAdmin";
import ServiceMember from "../../Member/Services/ServiceMember";
import {
  formatSpecailiteToLabelValue,
  formatVilleToLabelValue,
  formatSecteurToLabelValue,
} from "../../utils/utils";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { CheckAuthAContext } from "../../App";
import { Link } from "react-router-dom";
const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);
const AddAdmin = () => {
  const { checkAuthA, setCheckAuthA } = useContext(CheckAuthAContext);
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const [listSecteurs, setListSecteurs] = useState([]);
  const [formattedspecailite, setFormattedSpecailite] = useState();
  const [formattedSecteur, setFormattedSecteur] = useState();
  const [speciality, setSpeciality] = useState();
  const [firstName, setfirstName] = useState("");
  const [secteur, setSecteur] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [tel, setTel] = useState("");

  // const [adresse, setAdresse] = useState("");
  const [city, setCity] = useState("");
  const [formattedville, setFormattedVille] = useState();

  useEffect(() => {
    GetSpecailite();
    GetVille();
    // GetSecteur();
  }, []);
  const GetSpecailite = () => {
    ServiceAdmin.getSpecailite().then((res) => {
      setFormattedSpecailite(res.data.map(formatSpecailiteToLabelValue));
    });
  };
  const GetVille = () => {
    ServiceMember.getVille().then((res) => {
      setFormattedVille(res.data.map(formatVilleToLabelValue));
    });
  };

  const onChangeVille = (formattedville) => {
    setCity({
      id: formattedville.value,
      designation: formattedville.label,
    });

    ServiceMember.getSecteur(formattedville.value).then((res) => {
      setFormattedSecteur(res.data.map(formatSecteurToLabelValue));
    });
  };

  //message error
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  //loading
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const [cin, setCin] = useState(" ");
  const [adresse, setAdresse] = useState(" ");
  const HandleAddAdmin = (e) => {
    e.preventDefault();
    ServiceAdmin.addadmin(
      email,
      password,
      cin,
      firstName,
      lastName,
      tel,
      adresse,
      speciality,
      city,
      secteur
    ).then(
      (res) => {
        if (
          res.data.message.toString() ===
          "Un compte existe déja pour cette adresse email!"
        ) {
          setLoading(false);
          setMessage(res.data.message);
          setSeverity("error");
          setOpen(true);
        } else if (
          res.data.message.toString() ===
          "votre compte est en cours de creation, veuillez consulter votre boite email."
        ) {
          setLoading(false);
          setMessage(res.data.message);
          setSeverity("success");
          setOpen(true);
          window.location.replace("/");
        }
      },
      (error) => {
        setLoading(false);
        setMessage("Une erreur est produite lors de la création du compte");
        setSeverity("error");
        setOpen(true);
      }
    );
  };
  return (
    <>
      {!checkAuthA && (
        <div className="showcase-form card">
          <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={severity}>
              {message}
            </Alert>
          </Snackbar>
          <h4>Vous êtes praticien ? Un de nos experts vous recontacte</h4>
          <form
            onSubmit={(e) => {
              setLoading(true);
              HandleAddAdmin(e);
            }}
          >
            <Row>
              <Col>
                <Form.Control
                  type="text"
                  placeholder="Nom"
                  value={firstName}
                  onChange={(e) => setfirstName(e.target.value)}
                  required
                />
              </Col>
              <Col>
                <Form.Control
                  type="text"
                  placeholder="Prénom"
                  value={lastName}
                  onChange={(e) => setlastName(e.target.value)}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Control
                  type="text"
                  placeholder="Téléphone"
                  value={tel}
                  onChange={(e) => setTel(e.target.value)}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Select
                  placeholder="Ville"
                  width="90%"
                  styles={{
                    singleValue: (base) => ({
                      ...base,
                      padding: 5,
                      borderRadius: 5,
                      color: "white",
                      display: "flex",
                      color: "black",
                    }),
                  }}
                  components={{ SingleValue }}
                  isSearchable
                  name="label"
                  options={formattedville}
                  onChange={(formattedville) => {
                    onChangeVille(formattedville);
                  }}
                  required
                />
              </Col>
              <Col>
                <Select
                  placeholder="Secteur"
                  width="90%"
                  styles={{
                    singleValue: (base) => ({
                      ...base,
                      padding: 5,
                      borderRadius: 5,
                      color: "white",
                      display: "flex",
                      color: "black",
                    }),
                  }}
                  components={{ SingleValue }}
                  isSearchable
                  name="label"
                  options={formattedSecteur}
                  onChange={(formattedSecteur) => {
                    setSecteur({
                      id: formattedSecteur.value,
                      designation: formattedSecteur.label,
                    });
                  }}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Select
                  placeholder="Votre spécialité"
                  width="90%"
                  styles={{
                    singleValue: (base) => ({
                      ...base,
                      padding: 5,
                      borderRadius: 5,
                      color: "white",
                      display: "flex",
                      color: "black",
                    }),
                  }}
                  isClearable
                  components={{ SingleValue }}
                  isSearchable
                  name="label"
                  options={formattedspecailite}
                  onChange={(formattedspecailite) => {
                    setSpeciality({
                      id: formattedspecailite.value,
                      designation: formattedspecailite.label,
                    });
                  }}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Control
                  type="text"
                  placeholder="Adresse email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Button type="submit" className="mb-2">
                S'inscrire
              </Button>
            </Row>
            <Row>
              <p className="m-auto mt-3">
                J'ai déja un compte sur Doclic.
                <Link
                  onClick={() => {
                    setCheckAuthA(!checkAuthA);
                  }}
                >
                  Se connecter
                </Link>
              </p>
            </Row>
          </form>
          {loading ? (
            <div
              className="load"
              style={{ display: "inline-flex", margin: "0 auto 15px" }}
            >
              <Alert className="mr-2 w-30" severity="info">
                Attendez svp !
              </Alert>
              <Spinner animation="border" />
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default AddAdmin;
